var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{ref:"ckeditor",attrs:{"config":_vm.config},on:{"ready":_vm.ready}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.1@vue-loader/lib/template-compiler?{"id":"data-v-443e4d61","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/.13.7.1@vue-loader/lib/selector.js?type=template&index=0!./src/packages/components/editor/components/main.vue
// module id = 68
// module chunks = 0 1